import { render, staticRenderFns } from "./revisionesPendientes.vue?vue&type=template&id=796a21bb"
import script from "./revisionesPendientes.vue?vue&type=script&lang=js"
export * from "./revisionesPendientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports